<template>
  <div class="table-cell-avatar">
    <v-avatar
      :color="color"
      :size="size"
      class="mr-2"
    >
      <v-icon v-if="icon" small color="white">
        {{ icon }}
      </v-icon>
      <span v-else class="white--text text-subtitle-2">
        {{ initials }}
      </span>
    </v-avatar>
    <div class="table-cell-avatar__content">
      <div class="text-body-2 font-weight-medium">
        <slot>{{ primary }}</slot>
      </div>
      <div v-if="secondary" class="text-caption table-cell-avatar__secondary">
        {{ secondary }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import type { TableCellWithAvatarProps } from './types'

export default Vue.extend<any, any, any, TableCellWithAvatarProps>({
  name: 'TableCellWithAvatar',
  props: {
    primary: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: Number,
      default: 32
    }
  },
  computed: {
    initials(): string {
      if (!this.primary) return ''
      return this.primary
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    }
  }
})
</script>

<style scoped>
.table-cell-avatar {
  display: flex;
  align-items: center;
}

.table-cell-avatar__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.table-cell-avatar__secondary {
  color: var(--muted-foreground);
}
</style>
